import { UserTimeZone } from '@app/queryTyping';

export enum TimeZoneFormFields {
  TIME_ZONE = 'timeZone',
}

export type TimeZoneForm = {
  [TimeZoneFormFields.TIME_ZONE]: UserTimeZone
};
